import {API_ENDPOINT}  from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "../utils/utils";

let env = process.env.REACT_APP_API_BASE_URL

export const  vendorApi = async(data) => {
  let url = ""
  const page = data?.page === 0 || data?.page ? data?.page+1 : 1
  if (data?.id && (data?.id !== undefined || data?.id !== 'undefined')){
    url = `${env}${API_ENDPOINT.Vendor.api+"/"+data?.id}`
  }else{
    url = `${env}${API_ENDPOINT.Vendor.api+"?status="+(data?.status?data?.status:'')+"&location="+(data?.location?data?.location:'')+"&dateFrom="+(data?.dateFrom?data?.dateFrom:'')+"&dateTo="+(data?.dateTo?data?.dateTo:'')+"&page="+page+"&pageSize="+(data.pageSize?data.pageSize:'')+"&search="+(data.search?data.search:'')}`
  }
  const res = await requestInstance.get(
    url
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}
export const  addVendorApi = async(data) => {
  const res = await requestInstance.post(
    `${env}${API_ENDPOINT.Vendor.api}`,
    data
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}
export const  updateVendorApi = async(data) => {
  const res = await requestInstance.patch(
    `${env}${API_ENDPOINT.Vendor.api+"/"+data.vendorId}`,
    data.data
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}

export const  vendorUserApi = async(data) => {
  let url = ""
  const page = data?.page === 0 || data?.page ? data?.page+1 : 1
  if (data?.id && (data?.id !== undefined || data?.id !== 'undefined')){
    url = `${env}${API_ENDPOINT.Vendor.user+"/"+data?.id+"?search="+(data?.search?data?.search:'')+"&page="+page+"&pageSize="+(data?.pageSize?data?.pageSize:'')}`
  }
  const res = await requestInstance.get(
    url
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}
